/** The `{snippet:<uuid>}` reference grammar, shared by the editor and the expander.
 *
 * Kept in step with relay's `utils/snippets` by `snippet_token_cases.json`, which
 * both suites assert against. Leading indent is spaces-only (max 3) because a tab
 * makes the line an indented code block, which is never a reference.
 */
export const MDAST_SNIPPET_BLOCK = 'snippetBlock'

const UUID_SOURCE =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
const SNIPPET_LINE = new RegExp(`^ {0,3}\\{snippet:(${UUID_SOURCE})\\}[ \\t]*$`)

export function snippetIdFromLine(value: string): string | null {
  return SNIPPET_LINE.exec(value)?.[1]?.toLowerCase() ?? null
}

export function snippetReferenceMarkdown(id: string): string | null {
  return new RegExp(`^${UUID_SOURCE}$`, 'i').test(id)
    ? `{snippet:${id.toLowerCase()}}`
    : null
}
